import { api, API_PREFIX, withFallback } from './client'
import type { Vehicle, VehicleInput } from '../../types/api'

/** GET /vehicles (new) */
export async function listVehicles(params?: { search?: string; type?: string; active?: boolean }): Promise<Vehicle[]> {
  return withFallback(async () => {
    const res = await api.get<Vehicle[] | { items: Vehicle[] }>(`${API_PREFIX}/vehicles`, { params })
    const d = res.data
    return Array.isArray(d) ? d : (d?.items ?? [])
  }, [])
}

export async function createVehicle(body: VehicleInput): Promise<Vehicle> {
  const res = await api.post<Vehicle>(`${API_PREFIX}/vehicles`, body)
  return res.data
}

export async function updateVehicle(id: string, body: Partial<VehicleInput>): Promise<Vehicle> {
  const res = await api.patch<Vehicle>(`${API_PREFIX}/vehicles/${id}`, body)
  return res.data
}

export async function deactivateVehicle(id: string): Promise<void> {
  await api.delete(`${API_PREFIX}/vehicles/${id}`)
}
